import { doRequest } from "utils/core";

const promotionAPI = {
  getPromotion: (params) => {
    let url = `api/promotion/detail`;
    return doRequest("get", url, { params });
  },
  postEntry: (data) => {
    let url = `api/promotion/entry`;
    return doRequest("post", url, { data });
  },
};

export default promotionAPI;
